import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Button, Icon } from "semantic-ui-react";

import CopyString from "../utils/CopyString.jsx";

import { getDownloadTXT } from "../../state/reducers/downloads/downloadActions.js";

class VPNDetailsSection extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    getDownloadTXT: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false,
    copyKey: "resource.details_panel"
  };

  // -- FILE DOWNLOAD -- //

  onDownloadClick = () => {
    const { data, getDownloadTXT, copyKey, copy } = this.props;

    const fileName = `${data.id}-${copy(`${copyKey}.download_file_name`)}`;

    getDownloadTXT(data["@id"], fileName);
  };

  renderDownloadButton = () => {
    const { data, copyKey, copy } = this.props;

    if (!data["publicIP"] || !data["privateIP"]) return null;

    return (
      <Button
        as="a"
        icon={true}
        labelPosition="left"
        className="add-project-button"
        onClick={this.onDownloadClick}
      >
        <Icon name="download" />
        {copy(`${copyKey}.download_cta`)}
      </Button>
    );
  };

  // -- RENDER -- //

  render() {
    const {
      data: { sitePublicIP, siteSubnet, image },
      copyKey,
      copy
    } = this.props;

    if (!sitePublicIP && !siteSubnet) return null;

    // -- START - nasty WIRE GUARD HACK -- //
    // also adds image to props const above
    if (
      image["@id"] === "/images/CbJ2JZr7-vRiH-je6x-rZcn-f0gUnialAGyg" || // AWS
      image["@id"] === "/images/e4b95dbe-acdd-4fd8-894c-79d9f439538f" || // AWS 2
      image["@id"] === "/images/7721a7ac-c82a-4293-893a-bc5639e8b231" || // AWS 3
      image["@id"] === "/images/28afc343-94e9-45ae-93a8-bf41812df813" || // AWS - 18.2.7
      image["@id"] === "/images/40c9d930-6af0-45c3-815d-027f1d258dea" || // AWS - Rocky 8.9
      image["@id"] === "/images/370947af-9765-4fcb-93e2-5b273ecfc01b" || // AWS
      image["@id"] === "/images/797330f3-32a5-435f-ab8f-4d20769eaaae" || // GCP - Centos
      image["@id"] === "/images/1467bcb0-e07c-4f65-98f9-e6717b806b17" || // GCP - Rocky
      image["@id"] === "/images/d46cb380-8132-47d6-8fd3-22c552787484" || // GCP 3 - Rocky 8.8
      image["@id"] === "/images/4fcafdaa-2d43-4de1-ad9b-76ecc57ca84f" || // GCP 3 - 18.2.7
      image["@id"] === "/images/392617f9-9bf8-477e-a88f-7578b3d4effd" || // GCP - Rocky 8.9
      image["@id"] === "/images/2361024d-5d44-438e-a012-901a49829305" || // GCP
      image["@id"] === "/images/d8e495ad-67d2-467c-8b8a-443f98d63157" || // Azure - Rocky 8.8
      image["@id"] === "/images/9035b74a-c577-4c75-baf0-a0b639a1d03f" // Azure
    ) {
      return null;
    }
    // -- END - nasty WIRE GUARD HACK -- //

    return (
      <Fragment>
        <p>
          {sitePublicIP && (
            <Fragment>
              <strong>{copy(`${copyKey}.site_public_ip`)}: </strong>
              <CopyString copyText={sitePublicIP} displayText={sitePublicIP} />
              <br />
            </Fragment>
          )}
          {siteSubnet && (
            <Fragment>
              <strong>{copy(`${copyKey}.site_subnet`)}: </strong>
              <CopyString copyText={siteSubnet} displayText={siteSubnet} />
            </Fragment>
          )}
        </p>
        {this.renderDownloadButton()}
      </Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getDownloadTXT: (id, downloadName) =>
    dispatch(getDownloadTXT(id, downloadName))
});

export default connect(undefined, mapDispatchToProps)(VPNDetailsSection);
